import { router } from 'expo-router';
import { useCallback } from 'react';

import { useUser } from '../../user/providers/UserProvider';
import { useStytchUser } from './useAuth';

/**
 * Shared by LoginEmail and LoginOTP: Stytch auth succeeded, but this account
 * never finished signup (no Fruitful User exists yet) — send them back to
 * to finish it instead of hanging indefinitely.
 */
export const useRedirectToFinishSignup = () => {
    const { hasNoFruitfulUser } = useUser();
    const { user: stytchUser } = useStytchUser();

    const needsToFinishSignup =
        hasNoFruitfulUser && stytchUser?.user_id != null;

    const redirectToFinishSignup = useCallback(() => {
        if (stytchUser?.user_id == null) {
            return;
        }

        // The destination screen reads the identity straight from the Stytch
        // session hooks, so there's nothing to forward here.
        router.navigate('/sign-up/new-member/info');
    }, [stytchUser]);

    return { needsToFinishSignup, redirectToFinishSignup };
};
